EpiditorGdtTable = require './epiditor_gdt_table'

class GdtTableNodeView
  constructor: (@node, @view, @getPos, @portalsAPI, @exportMode, @options = {}) ->
    @dom = document.createElement 'div'
    @dom.className = 'epiditor-gdt-table-node'
    @render()

  update: (node) ->
    return false unless node.type is @node.type

    @node = node
    @render()
    true

  updateAttrs: (attrs, silent = false) =>
    pos = @getPos()
    newAttrs = _.extend {}, @node.attrs, attrs
    tr = @view.state.tr.setNodeMarkup pos, null, newAttrs
    if silent and not @view.editable
      @view.updateState @view.state.apply tr
      @options.onReadonlyAttrsUpdate? @view
    else
      @view.dispatch tr
      @view.focus() unless silent

  render: ->
    @portalsAPI.show
      container: @dom
      children: <EpiditorGdtTable
        attrs={@node.attrs}
        exportMode={@exportMode}
        focusEditor={=> @view.focus()}
        forceTableExpand={@options.forceTableExpand}
        isEditing={@view.editable}
        updateAttrs={@updateAttrs}
      />

  ignoreMutation: -> true

  stopEvent: (event) ->
    event.target?.closest?('button, input, textarea, select, .inserted-table_buttons-row, .embedded-html-editor')?

module.exports = GdtTableNodeView
